import { useQuery } from "@tanstack/react-query";
import { ReceivingDiscrepancyService } from "src/services";
import { APIError } from "src/errors";
import { queryKeys } from "src/constants";
import { IssueStatus } from "src/types";

export const useReceivingDiscrepancy = (
  purchaseOrderId: string,
  receivingDiscrepancyService: ReceivingDiscrepancyService,
  receivingDiscrepancyStatus?: IssueStatus
) => {
  const {
    data: receivingDiscrepancy,
    error: fetchError,
    isLoading,
    refetch,
    isRefetching
  } = useQuery({
    queryKey: queryKeys.receivingDiscrepancy(purchaseOrderId, receivingDiscrepancyStatus),
    queryFn: async () => {
      try {
        return await receivingDiscrepancyService.getPurchaseOrderReceivingDiscrepancy(
          purchaseOrderId,
          receivingDiscrepancyStatus
        );
      } catch (error) {
        if (error instanceof APIError && error.statusCode === 404) {
          return null;
        }
        throw error;
      }
    },
    enabled: !!purchaseOrderId,
    retry: false
  });

  return { receivingDiscrepancy, fetchError, isLoading, refetch, isRefetching };
};
